export default [
  {
    key: 0,
    appid: 'wx43cddada7b553cec',
    des: 'zijin'
  },
  {
    key: 1,
    appid: 'wxa432270a25dd972f',
    des: 'lezi'
  },
  {
    key: 2,
    appid: 'wx7c231ad9bef89b79',
    des: 'gd'
  },
  {
    key: 3,
    appid: 'wx57ddebee5ae12fbc',
    des: 'dev1'
  }
]
